import script from "./EventRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./EventRegistration.vue?vue&type=script&setup=true&lang=js"

import "./EventRegistration.vue?vue&type=style&index=0&id=01ac3156&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ac3156"]])

export default __exports__